
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client';
import { GET_BOAT_EQUIPMENTS } from 'graphql/boat/queries';
export function BoatEquipmentsCheckBox({ value, onChange, error, helperText }) {

    const [boatEquipmentsList, setBoatEquipmentsList] = useState(null)

    const [getBoatEquipmentsList, { loading: equipmentsListLoading, error: equipmentsListError }] = useLazyQuery(GET_BOAT_EQUIPMENTS, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.boatSafetyEquipment.length > 0) {
                setBoatEquipmentsList(data.boatSafetyEquipment)
            }
        },
    })

    // get Equipments List
    const getBoatEquipments = () => {
        getBoatEquipmentsList({
            variables: {
                "code": null
            },
        })
    }
    useEffect(() => {
        getBoatEquipments();
    }, [boatEquipmentsList]);

    const [selectedEquipments, setSelectedEquipments] = useState([]);

    const handleCheckboxChange = (event) => {
        const { value: checkboxValue, checked } = event.target;
        let equipments;
        if (checked) {
            equipments = [...value, checkboxValue]; // Add skill if checked
        } else {
            equipments = value.filter((skill) => skill !== checkboxValue); // Remove skill if unchecked
        }
        onChange(equipments); // Update Formik state
    };

    return (
        <>
            {equipmentsListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
            {equipmentsListError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch equipments!')}</div>
                </div>
            )}
            {!equipmentsListLoading && !equipmentsListError && boatEquipmentsList?.length === 0 && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No equipments found!')}</div>
                </div>
            )}
            {!equipmentsListLoading && !equipmentsListError && boatEquipmentsList?.length > 0 && (
                <div>
                    {boatEquipmentsList.map((equip) => (
                        <div key={equip.code} className="flex items-center">

                            <input
                                id='safety_equipments'
                                name='safety_equipments'
                                type="checkbox"
                                value={equip.code}
                                checked={value.includes(equip.code)}
                                onChange={handleCheckboxChange}
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                            />


                            <label htmlFor="quipments" className="ml-3 block text-sm font-medium leading-6 text-gray-900">
                                {equip.description.en}
                            </label>
                        </div>
                    ))}
                    {error && <p className="text-error text-xs mt-1">{helperText}</p>}
                </div >
            )
            }
        </>
    );
}